/***
 *
 *   CARD
 *   Universal container for grouping UI components together
 *
 *   PROPS
 *   title: title string (optional)
 *   loading: boolean to toggle the loading animation (optional)
 *   shadow: apply a box shadow
 *   center: center align the card
 *   noPadding: remove the padding
 *   restrictWidth: restrict the width of the card on large screens
 *
 **********/

import { type CSSProperties, type ReactNode } from 'react';
import { ClassHelper } from 'components/lib';
import Style from './card.tailwind.js';
import { UMLoader } from '@urbanmetrix/um-kit';

interface CardProps {
  title?: ReactNode;
  loading?: boolean;
  shadow?: boolean;
  center?: boolean;
  noPadding?: boolean;
  restrictWidth?: boolean;
  className?: string;
  last?: boolean;
  style?: CSSProperties;
  extraClass?: string;
  isStat?: boolean;
  isOverflowAuto?: boolean;
  children?: ReactNode;
}

export function Card(props: CardProps) {
  const cardStyle = ClassHelper(Style, {
    shadow: props.shadow,
    center: props.center,
    noPadding: props.noPadding,
    loading: props.loading,
    className: props.className,
    last: props.last,
    restrictWidth: props.restrictWidth,
  });

  return (
    <section
      className={`${cardStyle} ${props.extraClass ? props.extraClass : ''} ${props.isStat ? 'stat' : 'gravity-modal'} ${props.isOverflowAuto ? 'overflow-auto' : ''}`}
      style={props.style}
    >
      {props.title && (
        <header className={Style.header}>
          <h1 className={Style.title}>{props.title}</h1>
        </header>
      )}

      {props.loading ? <UMLoader /> : props.children}
    </section>
  );
}
